import React from "react";
import { NutriValues } from "../../data/nutriValues";
import { MacroBar } from "./MacroBar";
import { cn } from "../../lib/utils";

export const PersonNutriSummary = ({
  name,
  nutri,
}: {
  name: string;
  nutri: NutriValues;
}) => (
  <div className="flex w-full flex-col text-left">
    <div className="flex w-full items-center justify-between mb-2">
      <span className="text-sm font-semibold text-ink">{name}</span>
      <span className="text-gold font-bold">{Math.round(nutri.kcal)} kcal</span>
    </div>
    <MacroBar
      fat={nutri.fat}
      carbs={nutri.carbs}
      protein={nutri.protein}
      kcal={nutri.kcal}
      hideKcal
    />
  </div>
);

export const PersonNutriCard = ({
  name,
  nutri,
  className,
}: {
  name: string;
  nutri: NutriValues;
  className?: string;
}) => (
  <div
    className={cn(
      "rounded-card border border-line bg-surface-card shadow-card p-4",
      className,
    )}
  >
    <PersonNutriSummary name={name} nutri={nutri} />
  </div>
);
